import { LiveAnnouncer } from '@angular/cdk/a11y';
import {
  Component,
  HostListener,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { FilterDataComponent } from '../filter-data/filter-data.component';
import { CustomerAccountBusinessLogicService } from 'src/app/services/customer-account-business-logic.service';
import { param } from 'jquery';
import { ApiService } from 'src/app/services/api.service';
import { InteractionHistoryService } from 'src/app/services/interaction-history.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import { AlightTableComponent } from '../../common/alight-table/alight-table.component';
import * as Constants from '../../../models/Constants';
import _ from 'lodash';
import { TreeTableComponent } from '../../common/tree-table/tree-table.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';

export interface IHTransferDetail {
  TransferDate: string;
  StartTime: string;
  StopTime: string;
  AgentName: string;
  Topic: string;
  CustomerName?: string;
}

export interface IHTransferDetail1 {
  AccountOpened: string;
  Reason: string;
  Role: string;

}


const TRANSFER_DATA: IHTransferDetail[] = [
  //Static Data has been  used to show the table, and should be removed when consumed by Features.
  {
    TransferDate: 'Dec-10-2023',
    StartTime: '10:43:58 a.m. ',
    StopTime: '01:23:45p.m ',
    AgentName: 'Michael A',
    Topic: 'Lorem ipsum',
  },
  {
    TransferDate: 'Dec-10-2023',
    StartTime: '10:43:58 a.m. ',
    StopTime: '01:23:45p.m ',
    AgentName: 'Michael A',
    Topic: 'Lorem ipsum',
  },
];



const ADDITIONAL_DATA: IHTransferDetail1[] = [
  //Static Data has been  used to show the table, and should be removed when consumed by Features.
  {
    AccountOpened: 'McDermott, Patrick',
    Reason: 'Authorized user ',
    Role: 'HR/Manager '

  },
  {
    AccountOpened: 'John Doe',
    Reason: 'Agent ',
    Role: 'Michael A'

  }
];
@Component({
  selector: 'app-interaction-history-list-view',
  templateUrl: './interaction-history-list-view.component.html',
  styleUrls: ['./interaction-history-list-view.component.scss'],
})
export class InteractionHistoryListViewComponent implements OnInit {
  @ViewChild(AlightTableComponent) alightTable;
  @ViewChild(TreeTableComponent) alightTreeTable;
  iconConfig: any;
  IHListViewLoader: boolean = false;
  showLoaderMsg: boolean = false;
  loaderTimeoutId: any;
  apiFailed: boolean = false;
  apiFailureMsg = Constants.CARD_DATA_FAILURE_MSG;
  totalRecords: number = 0;
  showTransferDetail: boolean = false;
  showAdditionalInfo: boolean = false;
  showAdditionalAccountInfo: boolean = false;
  showMultipleAccountDetail: boolean = false;
  @Input('selectedRow') selectedRow: any;
  @Input('id') id: any;
  selectedRowDetailView: any = {};
  displayAlert: boolean = true;
  reasonForEdit :any ;
  apiFailureMsgForWrapUpComment  = Constants.SAVING_DATA_API_FAILURE_MSG;


  constructor(
    private _liveAnnouncer: LiveAnnouncer,
    public dialog: MatDialog,
    public cusAccService: CustomerAccountBusinessLogicService,
    public intHistService: InteractionHistoryService,
    private apiService: ApiService,
    public rootScopeService: RootScopeService
  ) { 
    this.intHistService.refreshIHData.subscribe({
      next: (res: boolean) => {
        if (res && this.intHistService.refreshListData) { 
          this.getData(); 
          this.intHistService.refreshListData=false; 
        }
      },
      error: (err: string) => { console.log(err) }
    })
  }
  @HostListener('window:resize', []) resize() {
    this.showTransferDetail = !this.showTransferDetail;
    this.showAdditionalInfo = !this.showAdditionalInfo;
    this.showAdditionalAccountInfo = !this.showAdditionalAccountInfo;
    this.showMultipleAccountDetail = !this.showMultipleAccountDetail;
  }

  ngOnInit(): void {

    

    this.rootScopeService.onResize();
    this.apiFailed = false;
    this.rootScopeService.scrollToTop();


   


    this.intHistService.isFilterApplied.subscribe((data) => {
      if (data) {
        this.selectedRow = this.intHistService?.treeData[0];
        this.rootScopeService.activeCustTab.IHSelectedRow = {'row' : this.selectedRow}
        this.selectedRowDetailView = this.intHistService?.treeData[0];
      }
    })
    
  }



  //Static Data has been  used to show the table, and should be removed when consumed by Features.

  displayedData: string[] = [
    'TransferDate',
    'StartTime',
    'StopTime',
    'AgentName',
    'Topic',
  ];

  displayedAdditionalData: string[] = [
    'AccountOpened',
    'Reason',
    'Role',

  ];

  dataTransfer = new MatTableDataSource(TRANSFER_DATA);

  additionalAccountData = new MatTableDataSource(ADDITIONAL_DATA);

  ngOnChanges(changes) {

    //  console.log('changes', this.rootScopeService.activeCustTab);
    if (changes.id.currentValue != changes.id.previousValue) {
      this.checkDataState();
    }
  }

  /**
   * Method to check whether tableData is already present
   * @author : Amarjeet
   */
  checkDataState() {
    let data;
    if (this.intHistService.IHListViewDataCAMap[this.rootScopeService.activeCustTab.customerSessionId]?.isFilterApplied) {
      data =
        this.intHistService.IHListFilterViewDataCAMap[
        this.rootScopeService.activeCustTab.customerSessionId
        ];
    }
    else {
      data =
        this.intHistService.IHListViewDataCAMap[
        this.rootScopeService.activeCustTab.customerSessionId
        ];
    }
    if (data) {
      this.intHistService.treeData = data;
      if(this.rootScopeService?.agenIneractionData?.isAgentRowClicked){
        this.setAgentInteractionRow();
    }
      this.setAlightTreeTable(this, this.rootScopeService.clonedActiveCustTab?.IHSelectedRow, data)
      this.intHistService.showAlightTableComponent = false;
      // }
      // else {
      //   this.intHistService.interHistListViewTableData = data;
      //   // this.intHistService.showAlightTableComponent = true; //commenting it as now not needed.
      //   this.rootScopeService.IHListCount = this.totalRecords;
      //   if (!this.selectedRow?.row) {
      //     if (this.intHistService.interHistListViewTableData.data && this.intHistService.interHistListViewTableData.data.length > 0)
      //       this.selectedRowDetailView = this.intHistService.interHistListViewTableData.data[0];
      //   }
      //   else
      //     this.selectedRowDetailView = this.getIHObj(this.selectedRow?.row, this.intHistService.interHistListViewTableData.data);

      //   this.setTableData();
      // }

      // this.rootScopeService.isFilterApplied = false;
      this.totalRecords = data.length;
      this.apiFailed = false;
    } else {
      this.intHistService.treeData = [];
      this.intHistService.showAlightTableComponent = true;
      this.getData();
    }

    if (this.rootScopeService.filterDomainListData.length == 0) {
      this.getFilterDomainList()
    }


  }



  setAlightTreeTable(self: any, selectedRow: any, data) {
    let that = this;
    let selectedObj;
     /* istanbul ignore next */
    if (selectedRow && selectedRow?.row) {
      console.log("selectedRow?.row?._id)", selectedRow?.row?._id)
      /**If selectedRow is parent or primary node */
      for (let i = 0; i < this.intHistService.treeData.length; i++) {
        let each = this.intHistService.treeData[i];
        if (each._id == selectedRow?.row?._id) {
          selectedObj = each;
          this.rootScopeService.activeCustTab.agenInteractionData.currentRowNumber = i+1;
          break;
        } else if (each?.children && each?.children?.length > 0) {
          /**If selectedRow is child node - CCR1-6628 */

          for (let j = 0; j < each?.children?.length; j++) {
            if (each?.children?.[j]?._id == selectedRow?.row?._id) {
              selectedObj = each;
              this.rootScopeService.activeCustTab.agenInteractionData.currentRowNumber = i + 1;
              break;
            }
          }
        }

      }
    }
    /* istanbul ignore next */
    setTimeout(() => {
      console.log("selectedObj", selectedObj)
       /* istanbul ignore next */
      if (self?.alightTreeTable) {
        self.alightTreeTable.selectedRow = selectedObj ? selectedObj : this.intHistService.treeData[0];
        this.selectedRow = selectedObj ? selectedObj : this.intHistService.treeData[0]; 
        this.selectedRowDetailView = selectedObj ? selectedObj : this.intHistService.treeData[0];
        // this.selectedRowDetailView = data[0] || this.alightTreeTable?.selectedRow || this.intHistService.interHistListViewTableData?.data[0];
        this.checkingRowselection();
      }
      this.intHistService.dataSource.next(data);

      const currentRowNumber = this.rootScopeService.activeCustTab.agenInteractionData?.currentRowNumber;
      const pageSize = self?.alightTreeTable?.pageSize;

      if (currentRowNumber && pageSize) {
        const currentPage = Math.ceil(currentRowNumber / pageSize);
        self?.alightTreeTable?.setPage(currentPage);
      }

    this.rootScopeService.agenIneractionData.isAgentRowClicked= false;

    }, 200);
  }

  /**
   * Method to set IH  List view data with pagination & sorting feature
   * @author :Amarjeet
   */
  setTableData() {
    setTimeout(() => {
      // this.intHistService.setAlightTreeTable(this, this.selectedRow)
      this.intHistService.setTableData(
        this,
        this.totalRecords,
        this.selectedRow
      );
      this.alightTable?.setGridSortAndPagination();
      // CCR3-2685
      if (!this.selectedRow?.row) {
        this.selectedRowDetailView = this.alightTreeTable?.selectedRow || this.intHistService.interHistListViewTableData?.data[0];
        this.checkingRowselection();

      }
    }, 200);
  }

  // CCR3-2685 Method to check rowSelection
  checkingRowselection() {
    console.log("selectedRowDetailView", this.selectedRowDetailView)
    if (this.selectedRowDetailView) {
      if (this.selectedRowDetailView?.children?.length > 0 || this.selectedRowDetailView?.documentDetail?.subject.id == this.selectedRowDetailView?.documentDetail?.contact.id) {
        this.selectedRowDetailView.accountType = Constants.selectionType.primary;

      } else if (
        this.selectedRowDetailView?.documentDetail?.subject.id !== this.selectedRowDetailView?.documentDetail?.contact.id
        && this.selectedRowDetailView?.topic === "Do Not Discuss"
      ) {
        this.selectedRowDetailView.accountType = Constants.selectionType.doNotDiscuss;


      } else if (this.selectedRowDetailView?.children?.length == 0 || this.selectedRowDetailView?.documentDetail?.subject.id !== this.selectedRowDetailView?.documentDetail?.contact.id) {
        this.selectedRowDetailView.accountType = Constants.selectionType.additional;


      }
    }
    // else {
    //   this.selectedRowDetailView.accountType = Constants.selectionType.regular;
    // }
  }
  // CCR3-2685
  onRowSelection(event) {
    let clone = _.cloneDeep(event);
    this.rootScopeService.activeCustTab.IHSelectedRow = clone;
    this.rootScopeService.clonedActiveCustTab.IHSelectedRow = clone;
    
    this.selectedRowDetailView = event.row;
    this.checkingRowselection();
    this.rootScopeService.activeCustTab.documentViewApiFailed = false; // CCR1-12776 resetting document view api failure state on row selection change

  }

  /**
   * Method to call IH  List view data API
   * @author :Amarjeet
   */
  getData() {
    this.IHListViewLoader = true;
    this.startTimerForLoader();
    /* istanbul ignore next */
    this.apiService.getIHDataForListView().subscribe({
      next: (data: any) => {

        if (data['data'] && data['data'].length > 0) {

          this.intHistService.modifyIHListViewData(data['data'], this.rootScopeService.activeCustTab.IHSelectedRow, this);
          this.totalRecords =
            this.intHistService.interHistListViewTableData.data.length;
          this.rootScopeService.IHListCount = this.totalRecords;
          // this.rootScopeService.isFilterApplied = false;
          //  console.log("this.selectedRow", this.selectedRow)
          let that = this;
          //   this.getSelectedRowDetailObj();
          data = this.intHistService.interHistListViewTableData.data;
          this.totalRecords = this.intHistService.interHistListViewTableData.data.length;


        if(this.rootScopeService?.agenIneractionData?.isAgentRowClicked){
            this.setAgentInteractionRow();
        }
            this.intHistService.setAlightTreeTable(this, this.rootScopeService.activeCustTab.IHSelectedRow)
        

         

          // if (!this.selectedRow?.row)
          //   this.selectedRowDetailView = data?.[0];
          // else
          //   this.selectedRowDetailView = this.getIHObj(this.selectedRow.row, data);


          //  console.log("this.selectedRow", this.selectedRowDetailView)
        } else {
          this.intHistService.IHListViewDataCAMap[
            this.rootScopeService.activeCustTab.customerSessionId
          ] = new MatTableDataSource([]);
          this.rootScopeService.IHListCount = 0;
          this.IHListViewLoader = false;
          this.showLoaderMsg = false;
        }
        // this.setTableData();
        this.intHistService.selectedRow = this.selectedRow?.row;
        // this.IHListViewLoader = false;
        // this.showLoaderMsg = false;

        clearTimeout(this.loaderTimeoutId);
      },
      error: (error) => {
        this.apiFailed = true;
        this.IHListViewLoader = false;
        this.showLoaderMsg = false;
        clearTimeout(this.loaderTimeoutId);
      },
    })
  }

  getSelectedRowDetailObj() {
    let data = {};
    if (this.intHistService.isAdditionlAccntCasePresent) {
      this.intHistService.isAdditionlAccntCasePresent = false;
      data = this.intHistService.treeData;
      this.totalRecords = this.intHistService.treeData.length;
      /* istanbul ignore next */
      setTimeout(() => {
        if (this.alightTreeTable)
          this.alightTreeTable.selectedRow = data[0];
      }, 100)
    }
    else {
      data = this.intHistService.interHistListViewTableData.data;
      this.totalRecords = this.intHistService.interHistListViewTableData.data.length;
    }

    if (!this.selectedRow?.row)
      this.selectedRowDetailView = data[0];
    else
      this.selectedRowDetailView = this.getIHObj(this.selectedRow?.row, data);
  }

  getIHObj(selectedIHObj, data): any {
    return _.find(
      data,
      function (each) {
        return each['_id'] == selectedIHObj?._id;
      }
    );
  }

  /**
   * Method to call loader during  IH  List view API request
   * @author :Amarjeet
   */
  startTimerForLoader() {
    let that = this;
    /* istanbul ignore next */
    this.loaderTimeoutId = setTimeout(() => {
      that.showLoaderMsg = true;
    }, 1 * this.rootScopeService.showLoaderMsgThreshold * 1000);
  }


  openFilter() {
    // this.dialog.open(FilterDataComponent, {
    //   panelClass: 'interaction-history-dialog',
    //   backdropClass: 'custom-overlay',
    //   id: 'filterPopup'
    // });
    // this.intHistService.interHistListViewTableData = this.intHistService.IHListViewDataCAMap[this.rootScopeService.activeCustTab.id];
    this.rootScopeService.openInteractionFilter = true;
    this.rootScopeService.accountModalPopup.set(this.rootScopeService.activeCustTab.customerSessionId,['openInteractionFilter' , true]);
    this.rootScopeService.activeCustTab.interactionFilterFail = false;
  }

  /**
     * Method to reset IH table data
     * @author :Amarjeet
     */
  clearFilter() {
    if (this.intHistService.showAlightTableComponent)
      this.intHistService.interHistListViewTableData = this.intHistService.IHListViewDataCAMap[this.rootScopeService.activeCustTab.customerSessionId];
    else {
      this.intHistService.setAlightTreeTable(this, this.selectedRow)

      let that = this;
      setTimeout(function () {
        that.intHistService.dataSource.next(that.intHistService.IHListViewDataCAMap[that.rootScopeService.activeCustTab.customerSessionId])
        that.intHistService.treeData = that.intHistService.IHListViewDataCAMap[that.rootScopeService.activeCustTab.customerSessionId];
      }, 0)
    }

    if (this.intHistService.IHListViewDataCAMap[this.rootScopeService.activeCustTab.customerSessionId]) {
      this.intHistService.IHListViewDataCAMap[this.rootScopeService.activeCustTab.customerSessionId].filterFormData = null;
      this.intHistService.IHListViewDataCAMap[this.rootScopeService.activeCustTab.customerSessionId].isFilterApplied = false;
    }

    if(this.intHistService.IHListFilterViewDataCAMap?.[this.rootScopeService.activeCustTab.customerSessionId]?.moreRecordFound){
      this.intHistService.IHListFilterViewDataCAMap[this.rootScopeService.activeCustTab.customerSessionId].moreRecordFound = false;
    }

    this.rootScopeService.activeCustTab.interactionFilterFail = false;
  }

  //CCR1-2071
  showFilter() {
    // console.log("showfilter", this.intHistService.IHListViewDataCAMap[this.rootScopeService.activeCustTab.id])
    // if (this.intHistService.IHListViewDataCAMap[this.rootScopeService.activeCustTab.customerSessionId]) {
    //   if (this.intHistService.IHListViewDataCAMap[this.rootScopeService.activeCustTab.customerSessionId]?.filteredData) {
    //     return this.intHistService.IHListViewDataCAMap[this.rootScopeService.activeCustTab.customerSessionId]?.filteredData.length > 0
    //   }
    //   else if (this.intHistService.IHListViewDataCAMap[this.rootScopeService.activeCustTab.customerSessionId].length > 0)
    //     return true;
    // }
    return true;
  }

  getTotalRecords() {

    let length: number = 0;
    if (this.intHistService.showAlightTableComponent)
      length = this.intHistService.interHistListViewTableData.data ? this.intHistService.interHistListViewTableData.data.length : 0;
    else
      length = this.intHistService.treeData ? this.intHistService.treeData.length : 0;

    return length ? length : 0;
  }

  toDisplayAlert() {
    this.displayAlert = this.rootScopeService.activeCustTab.showRepeatAlert;
    return this.displayAlert;
  }

  closeWarning() {
    this.rootScopeService.activeCustTab.showRepeatAlertListView = !this.rootScopeService.activeCustTab.showRepeatAlertListView;

  }

  /** 
  * getDomainList -- calling API to get getDomainList.
  * @author :Amarjeet Kumar
  */
  getFilterDomainList() {
    this.apiService.getFilterDomainList().subscribe({
      next: (data: any) => {
        this.rootScopeService.filterDomainListData = data.data;
      },
      error: (error) => {
        console.log(error)
      },
    })
  }

  setAgentInteractionRow(){
    let selRow = this.rootScopeService?.agenIneractionData?.selectedRow;
      const filteredRow = _.find(this.intHistService?.treeData, (x) => {
        return x.externalRefId === selRow?.externalRefId &&
        x?.delegate?.delegateId === selRow?.delegate?.delegateId
       
      });
      let transferedRow;


      let row ={
        row: filteredRow,
        buttonName: 'Customer Account'
      }
      if(filteredRow)
        this.rootScopeService.activeCustTab.IHSelectedRow = row;
        this.rootScopeService.clonedActiveCustTab.IHSelectedRow = row;
  }
 


  /**
   * CCR1-7186
   * Below method is called when user clicks on submit button
   * of edit wrap up modal
   */

  onSubmit(){
    console.log("Method onsubmit called",this.intHistService.editWrapupCommentsForm)
    this.rootScopeService.activeCustTab.saveWrapUpCommentApiFailure = false;
    let collectionName = this.intHistService.getCollectionName(this.intHistService.selectedIHForWrapUpCommentsEdit.begin);
    let reqBody = new FormData();
    reqBody.append('comments',this.intHistService.editWrapupCommentsForm.value.comments+"");
    reqBody.append('reason',this.intHistService.editWrapupCommentsForm.value.reason+"");
    reqBody.append('documentId',this.intHistService.selectedIHForWrapUpCommentsEdit._id);
    reqBody.append('date',new Date().toISOString());
    reqBody.append('collectionName',collectionName);
    /* istanbul ignore next */
    this.apiService.saveUpdatedWrapupComments(reqBody).subscribe((data)=>{
      console.log("data",data)
      this.intHistService.clonedFormObject = _.cloneDeep(this.intHistService.editWrapupCommentsForm);
      this.intHistService.commentValChanged.next(true);
      this.rootScopeService.activeCustTab.showEditCommentsModal = false;
      this.intHistService.editWrapupCommentsForm.reset();
    },
    (error)=>{
      this.rootScopeService.activeCustTab.saveWrapUpCommentApiFailure = true;
    })
  }

  closeModal() {   
    this.rootScopeService.activeCustTab.showEditCommentsModal = false;
    this.intHistService.editWrapupCommentsForm.reset();
    this.rootScopeService.activeCustTab.saveWrapUpCommentApiFailure = false
  }

  enableWrapupCommentSubmitButton(){
    console.log("wrapup comment = ",this.intHistService.selectedIHForWrapUpCommentsEdit?.documentDetail?.details)
    console.log("reason  =", this.reasonForEdit)
    if(this.intHistService.selectedIHForWrapUpCommentsEdit?.documentDetail?.details && this.intHistService.selectedIHForWrapUpCommentsEdit?.documentDetail?.details != '' && this.reasonForEdit != ''){
       return true;
    }
    else{
      return false;
    }
  }

  onTextareaChanged(event: any) {
    if(event?.detail?.value?.length) {      
       this.intHistService.editWrapupCommentsForm.get('comments')?.setValue(event.detail.value);
    }
  }

  onTextareaChangedReason(event: any) {
   
    if(event?.detail?.value?.length > 1000) {      
      this.intHistService.editWrapupCommentsForm.get('reason')?.setValue(event.detail.value.substring(0, 1000));
    }

  }
  
}
